import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { AuthService } from "../../../../../services/auth.service";
import { SharedService } from "../../../../../services/shared.service";
import { ActivatedRoute, Router } from "@angular/router";
import {
  IMatrizConsolidadaUgSecaoVM, IMatrizConstatacaoModel,
  IMatrizDefinitivaConsolidadaResponse,
  IOsaExecucaoMatrizConstatacaoItemModel
} from "../../../../../models/constatacao.model";
import { MatTableDataSource } from "@angular/material/table";
import { MatrizConstatacoesService } from "../../../../../services/matriz-constatacao.service";
import Swal from "sweetalert2";

@Component({
  selector: 'app-imprimir-matriz-constacacao',
  templateUrl: './imprimir-matriz-constatacao.component.html',
  styleUrls: ['./imprimir-matriz-constatacao.component.scss']
})

export class ImprimirMatrizConstatacaoComponent implements OnInit {

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('maxLengthEditor') private angularEditor: any;

  public consolidadaId = 0;
  dataAtual = new Date();
  public model: IMatrizDefinitivaConsolidadaResponse = {} as IMatrizDefinitivaConsolidadaResponse;
  public secoesConsolidadasVM: IMatrizConsolidadaUgSecaoVM[] = [];
  public matriz: IMatrizConstatacaoModel;
  public tipoMatriz = '';
  public numeroOsa: string = '____';
  public osaExecucaoId = 0;

  public displayedColumnsPrint: string[] = [
    'constacao',
    'situacaoEncontrada',
    'riscosVinculados',
    'criteriosInfringidos',
    'evidencias',
    'causas',
    'efeitos',
    'recomendacoes'
  ];

  constructor(
    public authService: AuthService,
    public sharedaService: SharedService,
    public route: ActivatedRoute,
    public matrizConstatacoesService: MatrizConstatacoesService,
    public router: Router,
  ) {

    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state as any;

    if (state?.secoes?.length) {
      this.secoesConsolidadasVM = state.secoes;
      this.numeroOsa = state.numeroOsa || '____';
    }
  }

  ngOnInit(): void {
    this.consolidadaId = Number(this.route.snapshot.paramMap.get('id')) || 0;
    this.osaExecucaoId = Number(this.route.snapshot.queryParamMap.get('osaExecucaoId')) || 0;

    if (!this.consolidadaId) {
      this.exibirErro('Id da Matriz Consolidada inválido.');
      this.cancelar();
      return;
    }

    // ✅ Se não tem seções (reload ou acesso direto), busca via API
    if (!this.secoesConsolidadasVM.length) {
      if (!this.osaExecucaoId) {
        this.exibirErro('Parâmetros insuficientes para carregar a matriz.');
        this.cancelar();
        return;
      }
      this.obterConsolidada();
    }
  }

  private obterConsolidada(): void {
    this.matrizConstatacoesService.obterMatrizDefinitivaConsolidada(this.osaExecucaoId)
      .then((res) => {
        if (res?.sucesso && res?.dados) {
          this.secoesConsolidadasVM = (res.dados.secoes || []).map((s, idx) => ({
            ...s,
            headingId: `heading-consolidada-ug-${idx}`,
            collapseId: `collapse-consolidada-ug-${idx}`,
            dataSource: null,
            semDados: !s.itensFinalizados || s.itensFinalizados.length === 0
          }));
          this.numeroOsa = this.sharedaService?.getNumeroOsa?.() || '____';
        } else {
          this.exibirErro(res?.mensagem?.descricao || 'Consolidada não encontrada.');
          this.cancelar();
        }
      })
      .catch((err) => {
        this.exibirErro(err?.mensagem?.descricao || 'Erro ao carregar Consolidada.');
        this.cancelar();
      });
  }

  public  pegarAnoOsa(valor: string): string | null {
    if (!valor) return null;

    const match = valor.match(/\.(\d{4})/);

    return match ? match[1] : null;
  }

   public obterTipoMatriz(tipo: number): string {
    switch (tipo) {
      case 1:
        return 'Matriz Preliminar';
      case 2:
        return 'Matriz Consolidada';
      case 3:
        return 'Matriz Consolidada Definitiva';
      default:
        return 'Tipo de Matriz desconhecido';
    }
  }

  private exibirErro(mensagem: string): void {
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'error',
      text: mensagem,
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true
    });
  }


  public get unidadeGestoraCabecalho(): string {
    const primeiro = (this.secoesConsolidadasVM && this.secoesConsolidadasVM.length > 0)
      ? this.secoesConsolidadasVM[0]
      : null;

    return (primeiro && primeiro.unidadeGestoraNome)
      ? primeiro.unidadeGestoraNome
      : '-';
  }


  extrairUrl(texto: string): string {
    if (!texto) return '';

    // Se já for uma URL completa, retorna
    if (texto.startsWith('http://') || texto.startsWith('https://')) {
      return texto;
    }

    // Tenta extrair URL do texto
    const urlMatch = texto.match(/(https?:\/\/[^\s]+)/);
    return urlMatch ? urlMatch[0] : texto;
  }


  extrairTextoSemPrefixo(texto: string): string {
    if (!texto) return '';

    // Remove os prefixos "Arquivo:", "Link:", "Justificativa:"
    return texto
      .replace(/^Arquivo:\s*/i, '')
      .replace(/^Link:\s*/i, '')
      .replace(/^Justificativa:\s*/i, '')
      .trim();
  }

  formatarUrl(url: string): string {
    if (!url) return '';

    // Se já começa com http:// ou https://, retorna como está
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }

    // Caso contrário, adiciona https://
    return 'https://' + url;
  }
  public getStatusMatrizDescricao(statusCodigo: number | undefined): string {
    if (!statusCodigo) return 'Desconhecido';

    switch (statusCodigo) {
      case 1: // NaoIniciada
        return 'Não iniciada';
      case 2: // EmElaboracao
        return 'Em Elaboração';
      case 3: // Finalizada
        return 'Finalizada';
      case 4: // Aprovada
        return 'Aprovada';
      default:
        return 'Desconhecido';
    }
  }

  public cancelar(): void {
    window.history.back();
  }

  public print(): void {
    window.print();
  }

  formatarRecomendacoes(recomendacoes: any[]): string {
    if (!recomendacoes || recomendacoes.length === 0) return '-';

    const textos = recomendacoes
      .map(rec => rec.titulo || rec.descricao || '')
      .filter(texto => texto);

    if (textos.length === 0) return '-';

    return textos
      .map((texto, i) => textos.length > 1 ? `Rec.${String(i + 1).padStart(2, '0')}: ${texto}` : texto)
      .join('\n');
  }
}
